import { Chip, Typography } from "@mui/material";
import { useState } from "react";
import { QuestionInfo } from "../../../assets/common-svg/CommonSvg";
import CustomDrawer from "../../../components/custom-drawer/CustomDrawer";
import HeaderBackNav from "../../../components/header-back-navigation/HeaderBackNav";
import { fetchQueryHistory } from "../../../bmr/slices/queryInBound";
import CustomAccordion from "../../../components/custom-accordion/CustomAccordion";
import { FormValues } from "../../../components/form-template/FormValues";
import { FormCommentList } from "../../../components/form-template/FormCommentList";
import NoDataCard from "../../../components/no-data-card";
import { useDispatch } from "react-redux";
import { parseDynamicValue,combineLabelTitle } from "../../../utils/utils"
import { notify } from "../../../bmr/utils/methods/notification";

const InBoundQueryHistory = ({ inBoundId }) => {
  const dispatch = useDispatch();
  const [queryHistory, setQueryHistory] = useState([]);
  const [historyDrawer, setHistoryDrawer] = useState(false);

  const handleHistoryToggle = async () => {
    getHistory();
  };

  const getHistory = async () => {
    const res = await dispatch(fetchQueryHistory(inBoundId));
    if (fetchQueryHistory.fulfilled.match(res)) {
      setHistoryDrawer(true);
      let data = res?.payload?.data?.map((op) => {
        return {
          title: combineLabelTitle(op.field_label,op.field_name),
          leftBorder: false,
          backgroundColor: "#F0F1F5",
          color: "#000000",
          expanded: false,
          status: op.status,
          menuData: op.queries_comment.map((op) => {
            return {
              title: `${op.raised_by} (${op.role})`,
              name: `${op.raised_by[0]}${op.raised_by[1]}`,
              describe: op.query,
              date: op.created_at,
            };
          }),
          values: {
            previous_value: op.previous_value,
            new_value: op.new_value,
          },
        };
      });
      setQueryHistory(data);
    }else{
      notify.error(res?.payload)
    }
  };

  const toggleDrawer = () => {
    setHistoryDrawer(false);
  };

  const handleQuery = (index) => {
    let s1 = [...queryHistory];
    if (s1[index] && s1[index].expanded !== undefined) {
      s1[index].expanded = !s1[index].expanded;
    }
    setQueryHistory(s1);
  };


  return (
    <div>
      <div className="flex flex-row-reverse mt-2">
        <div className="flex gap-2">
          <Typography variant="h6">Query History</Typography>
          <span
            className="cursor-pointer"
            onClick={() => handleHistoryToggle()}
          >
            <QuestionInfo />
          </span>
        </div>
      </div>
      <CustomDrawer open={historyDrawer} toggleDrawer={toggleDrawer}>
        <div className="pl-4 pt-4 pr-4">
          <HeaderBackNav
            handleBackNav={toggleDrawer}
            TitleFontSize={"18px"}
            TitleFontWeight={700}
            Title={"Query History"}
          />
        </div>
        <hr />
        <div className="pl-4 pt-4 pr-4">
          {queryHistory?.length != 0 ? (
            queryHistory.map((query, index) => (
              <CustomAccordion
                key={index}
                accordionClassName={"w-[25rem] "}
                rootDivClass={"pb-3"}
                index={index}
                chip={
                  <Chip
                    label={
                      query.status == 0
                        ? "Not resolved"
                        : query.status == 1
                          ? "Resolved"
                          : "Reject"
                    }
                    color={
                      query.status == 0
                        ? "warning"
                        : query.status == 1
                          ? "success"
                          : "error"
                    }
                  />
                }
                expanded={query?.expanded}
                handleExpansion={handleQuery}
                color={query?.color}
                backgroundColor={query?.backgroundColor}
                title={query?.title}
              >
                {query.status == 2 ? (
                  <div className="w-100 text-center mb-3">
                    <div className="text-zinc-500 text-sm font-normal font-['Public Sans'] pb-1">
                      Current Value
                    </div>
                    <div className="px-2 py-1 bg-orange-400 rounded justify-center items-start gap-2.5 inline-flex">
                      <div className="text-white text-sm font-normal font-['Public Sans'] break-all">
                        {query?.values?.previous_value}
                      </div>
                    </div>
                  </div>
                ) : (

                  <FormValues
                    leftLable={"Previous Value"}
                    leftValue={query?.values?.previous_value}
                    rightLable={"New Value"}
                    rightValue={parseDynamicValue(query?.values?.new_value) ?? "N/A"}
                  />
                )}
                <hr className="pb-3" />
                <div>
                  <FormCommentList MenuData={query.menuData} />
                </div>
              </CustomAccordion>
            ))
          ) : (
            <div className="mt-4">
              <NoDataCard />
            </div>
          )}
        </div>
      </CustomDrawer>
    
    </div>
  );
};
export default InBoundQueryHistory;
